// assets/sh-component-checkout-popup-message.css
class PopupMessage extends HTMLElement {
    constructor() {
      super();
      // Selectors for relevant elements
      this.selectors = {
        checkoutBtn: ".js-checkout", 
        checkoutOverlay: ".js-sh-checkout-overlay", 
        checkoutPopup: ".js-checkout-popup",
        cancelCheckoutBtn: ".js-cancel-checkout" 
      };
  
      // Query DOM elements based on selectors
      this.checkoutBtn = document.querySelector(this.selectors.checkoutBtn);
      this.checkoutOverlay = document.querySelector(this.selectors.checkoutOverlay);
      this.checkoutPopup = document.querySelector(this.selectors.checkoutPopup);
      this.cancelCheckoutBtn = document.querySelector(this.selectors.cancelCheckoutBtn);
  
      // Bind event handlers to ensure `this` context is maintained
      this.showPopup = this.showPopup.bind(this);
      this.hidePopup = this.hidePopup.bind(this);
      this.handleClickOutside = this.handleClickOutside.bind(this);
    }
  
    // Called when the element is added to the DOM
    connectedCallback() {
      // Add event listener for the checkout button to show the popup
      if (this.checkoutBtn) {
        this.checkoutBtn.addEventListener("click", this.showPopup);
      }
      // Add event listener for the cancel button to hide the popup
      if (this.cancelCheckoutBtn) {
        this.cancelCheckoutBtn.addEventListener("click", this.hidePopup);
      }
      // Add event listener to handle clicks outside the popup
      document.addEventListener("click", this.handleClickOutside);
    }
  
    // Called when the element is removed from the DOM
    disconnectedCallback() {
      // Remove event listener for the checkout button
      if (this.checkoutBtn) {
        this.checkoutBtn.removeEventListener("click", this.showPopup);
      }
      // Remove event listener for the cancel button
      if (this.cancelCheckoutBtn) {
        this.cancelCheckoutBtn.removeEventListener("click", this.hidePopup);
      }
      // Remove event listener for clicks outside the popup
      document.removeEventListener("click", this.handleClickOutside);
    }
  
    // Function to show the popup
    showPopup(ev) {
      this.checkoutOverlay.style.display = "block";
      this.checkoutPopup.style.display = "block"
    }
  
    // Function to hide the popup
    hidePopup(ev) {
      this.checkoutOverlay.style.display = "none"; 
      this.checkoutPopup.style.display = "none"; 
    }
  
    // Function to handle clicks outside the popup
    handleClickOutside(ev) {
      // Check if the click was on the overlay
      if (ev.target === this.checkoutOverlay) {
        // Hide the popup if the click was on the overlay
        this.hidePopup(); 
      }
    }
  }
  
  // Define the custom element
  customElements.define('sh-popup-message', PopupMessage);
  
  
